import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=55a2c272"
import script from "./ErrorNotification.vue?vue&type=script&lang=js"
export * from "./ErrorNotification.vue?vue&type=script&lang=js"
import style0 from "./ErrorNotification.vue?vue&type=style&index=0&id=55a2c272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports